module.exports = __webpack_public_path__ + "media/images/pomp_and_sass_logo-0e33cdfc7716b29f6a22f11591eb5882.png";